import { render, staticRenderFns } from "./GFDeRegistration.vue?vue&type=template&id=4f8047a4"
import script from "./GFDeRegistration.vue?vue&type=script&lang=js"
export * from "./GFDeRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports